<script>
export default {
    name: "CurrentDischarge",

    data() {

        return {
            patients: [],
        };
    },

    mounted() {
        this.$root.loading=true;
        Promise.allSettled([ this.fetchDischarges(), ]).then(() => {
            this.$root.loading=false;
            setTimeout(() => {
                window.print();
            }, 250);
        }).catch(() => { this.$root.loading=false; });
    },

    methods: {

        fetchDischarges() {
            let url = `Morgue/GetPendingMorgueDischarges`;

            return this.$http.get(url).then(response => {
                this.patients = response.data;
            }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="w-full flex flex-wrap mx-2">
        <table class="table table-hover">
            <tbody class="text-sm flex flex-col items-center 
                overflow-auto w-full">
                <tr class="flex w-full text-base">
                    <th class="p-tiny w-1/6">Patient</th>
                    <th class="p-tiny flex-1">MRN</th>
                    <th class="p-tiny flex-1">Gender</th>
                    <th class="p-tiny flex-1">DOB</th>
                    <th class="p-tiny flex-1">Bed</th>
                    <th class="p-tiny flex-1">Package</th>
                    <th class="p-tiny flex-1">Date</th>
                    <th class="p-tiny flex-1">Burial Cert</th>
                    <th class="p-tiny flex-1">Death Cert</th>
                    <th class="p-tiny flex-1">Morgue No</th>
                    <th class="p-tiny flex-1">Approved</th>
                </tr>
                <tr class="flex w-full" v-for="(pat, idx) in patients" :key="idx">
                    <td class="p-tiny w-1/6">{{ pat.patient }}</td>
                    <td class="p-tiny flex-1">{{ pat.patientID }}</td>
                    <td class="p-tiny flex-1">{{ pat.gender }}</td>
                    <td class="p-tiny flex-1">{{ pat.dob | dateFormat }}</td>
                    <td class="p-tiny flex-1">{{ pat.bed }}</td>
                    <td class="p-tiny flex-1">{{ pat.package }}</td>
                    <td class="p-tiny flex-1">{{ pat.dischargeDate | dateFormat }}</td>
                    <td class="p-tiny flex-1">{{ pat.burialPermit || `-` }}</td>
                    <td class="p-tiny flex-1">{{ pat.deathCertNo || `-` }}</td>
                    <td class="p-tiny flex-1">{{ pat.morgueNo || `-` }}</td>
                    <td class="p-tiny flex-1">{{ pat.approved ? `Yes` : `No` }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>